<div class="modal-header">
  <h4 class="modal-title">
    {{ title }}
  </h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close mb-12px" type="button"></button>
</div>

<div class="modal-body">
  <div class="message-text">{{ message }}</div>

  <div *ngIf="fileService.uploader?.queue?.length" class="card-body">
    <table class="table table-hover">
      <thead>
      <tr>
        <th [style.width]="'50%'">Name</th>
        <th>Size</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of fileService.uploader.queue">
        <td><strong>{{ item?.file?.name }}</strong></td>
        <td>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</td>
        <td class="text-center">
          <span *ngIf="item.isSuccess"><i class="fal fa-ok"></i></span>
          <span *ngIf="item.isCancel"><i class="fa-regular fa-circle-xmark"></i></span>
          <span *ngIf="item.isError"><i class="fal fa-remove"></i></span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <ng-container *ngIf="!fileService.uploader?.queue?.length">
    <input #uploadInput [uploader]="fileService.uploader" class="form-control w-100" id="fileUpload" ng2FileSelect
           type="file"/>

    <div class="d-flex justify-content-center mt-40px">
      <div class="mb-3 w-100">
          <textarea (keyup)="onKeyInputCells($event)" [(ngModel)]="inputCells" class="form-control"
                    placeholder="Copy cells including headers from Excel and paste it here"
                    rows="7">
          </textarea>
      </div>
    </div>
    <div class="clearfix mb-3">
      <div *ngIf="pagedItems" class="card card-default">
        <div class="card-body bb">
          <div class="d-flex align-items-center">
            <div class="me-auto">
              <span>{{ tsvJson?.length | number }} Rows</span>
            </div>
            <div class="d-flex">
              <ul *ngIf="pager.pages && pager.pages.length" class="pager">
                <span class="mr-16px">{{ pager.currentPage }} of {{ pager.totalPages }}</span>
                <li [ngClass]="{disabled:pager.currentPage === 1}">
                  <a (click)="setPage(pager.currentPage - 1)" class="btn-cursor"><</a>
                </li>
                <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                  <a (click)="setPage(pager.currentPage + 1)" class="btn-cursor">></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body py-0">
          <div class="table-page-container">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>No</th>
                <th *ngFor="let header of tsvHeaders">{{ header }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf="pagedItems">
                <tr *ngFor="let item of pagedItems; index as i;">
                  <td>{{ (pager.currentPage - 1) * pager.pageSize + i + 1 }}</td>
                  <td *ngFor="let header of tsvHeaders">
                    {{ item[header] }}
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button (click)="downloadTemplate()" class="btn btn-outline-dark btn-lg wd-200px" type="button">Download Template
  </button>
  <button (click)="confirm()" *ngIf="!inputCells?.length" [disabled]="!fileService.uploader?.queue?.length"
          [hidden]="fileService.uploader?.isUploading" class="btn btn-dark ms-auto btn-lg wd-153px"
          type="button">Upload
  </button>
  <button (click)="uploadInputCells()" *ngIf="inputCells?.length" [disabled]="!inputCells?.length"
          [hidden]="fileService.uploader?.isUploading" class="btn btn-dark ms-auto btn-lg wd-153px" type="button">
    Upload
  </button>
  <button (click)="remove()" [hidden]="!fileService.uploader?.queue?.length || fileService.uploader?.isUploading"
          class="btn btn-outline-dark ml-12px btn-lg wd-153px"
          type="button">Remove
  </button>
</div>
